module.exports = __webpack_public_path__ + "img/Certificate.6f41d4f2.jpg";